import { render, staticRenderFns } from "./media-viewer.vue?vue&type=template&id=087855dc&scoped=true"
import script from "./media-viewer.ts?vue&type=script&lang=ts&external"
export * from "./media-viewer.ts?vue&type=script&lang=ts&external"
import style0 from "./media-viewer.less?vue&type=style&index=0&id=087855dc&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087855dc",
  null
  
)

export default component.exports